import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { observable, computed, action } from 'mobx';
import { task } from 'mobx-task';
import { Store } from 'libx';
var NotificationsViewStore = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _dec5 = action.bound, _dec6 = task.resolved, _class = /*#__PURE__*/function (_Store) {
  function NotificationsViewStore(workspace, rootStore) {
    var _this;
    _classCallCheck(this, NotificationsViewStore);
    _this = _callSuper(this, NotificationsViewStore, arguments);
    _initializerDefineProperty(_this, "showing", _descriptor, _this);
    _this.workspace = workspace;
    _this.rootStore = rootStore;
    _this.markAllAsRead = _this.markAllAsRead.bind(_this);

    // call the notificationScrollProvider to get a first fetch
    _this.notificationsScrollProvider = _this.rootStore.notificationStore.getScrollProviderForWorkspace(_this.workspace.id);
    return _this;
  }
  _inherits(NotificationsViewStore, _Store);
  return _createClass(NotificationsViewStore, [{
    key: "notifications",
    get: function get() {
      var _this2 = this;
      return this.rootStore.notificationStore.notifications.orderBy(['dateDispatch'], ['desc']).filter(function (x) {
        return x.workspaceId === _this2.workspace.id;
      });
    }
  }, {
    key: "unreadCount",
    get: function get() {
      var _this3 = this;
      return this.notifications.filter(function (x) {
        return x.status !== 'Read' && x.workspaceId === _this3.workspace.id;
      }).length;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.showing = !this.showing;
    }
  }, {
    key: "close",
    value: function close() {
      this.showing = false;
    }
  }, {
    key: "showPreferences",
    value: function () {
      var _showPreferences = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.close();
              _context.next = 3;
              return this.rootStore.notificationActionStore.showPreferences(this.workspace.id);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function showPreferences() {
        return _showPreferences.apply(this, arguments);
      }
      return showPreferences;
    }()
  }, {
    key: "switchToAssociatedWorkspace",
    value: function () {
      var _switchToAssociatedWorkspace = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this4 = this;
        var workspace;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.close();
              if (!(this.workspace.id !== this.rootStore.sessionStore.workspace.id)) {
                _context2.next = 5;
                break;
              }
              workspace = this.rootStore.workspaceStore.workspaces.find(function (x) {
                return x.id === _this4.workspace.id;
              });
              _context2.next = 5;
              return this.rootStore.workspaceSelectorStore.selectWorkspace(workspace);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function switchToAssociatedWorkspace() {
        return _switchToAssociatedWorkspace.apply(this, arguments);
      }
      return switchToAssociatedWorkspace;
    }()
  }, {
    key: "triggerAction",
    value: function triggerAction(notification) {
      this.markAsRead(notification);
      this.close();
      if (!notification.action) {
        return;
      }
      return this.rootStore.notificationActionStore.triggerAction(notification);
    }
  }, {
    key: "markAsRead",
    value: function () {
      var _markAsRead = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(notification) {
        var prev;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(notification.status === 'Read')) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              prev = notification.status;
              notification.set({
                status: 'Read'
              });
              _context3.next = 6;
              return this.rootStore.notificationStore.changeStatus({
                id: notification.id,
                status: 'Read'
              }).catch(function (err) {
                notification.set({
                  status: prev
                });
                throw err;
              });
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function markAsRead(_x) {
        return _markAsRead.apply(this, arguments);
      }
      return markAsRead;
    }()
  }, {
    key: "markAllAsRead",
    value: function () {
      var _markAllAsRead = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.rootStore.notificationStore.markAllAsRead({
                workspaceId: this.workspace.id
              }));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function markAllAsRead() {
        return _markAllAsRead.apply(this, arguments);
      }
      return markAllAsRead;
    }()
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "showing", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "notifications", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "notifications"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unreadCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unreadCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggle", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPreferences", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "showPreferences"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "switchToAssociatedWorkspace", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "switchToAssociatedWorkspace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triggerAction", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "triggerAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markAllAsRead", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "markAllAsRead"), _class.prototype), _class);
export { NotificationsViewStore as default };
//# sourceMappingURL=NotificationsViewStore.js.map
